import { render } from "./toDoItem.vue?vue&type=template&id=16ff36e4&scoped=true"
import script from "./toDoItem.vue?vue&type=script&lang=js"
export * from "./toDoItem.vue?vue&type=script&lang=js"

import "./toDoItem.vue?vue&type=style&index=0&id=16ff36e4&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ff36e4"]])

export default __exports__